import { useSelector } from "react-redux"
import styled from "styled-components"

const Container = styled.h3`
  width: 100%;
  font-size: 18px;
  font-weight: var(--font-weight-lg);
  line-height: 21px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  color: var(--color-main);
  text-align: ${({ textAlign }) => textAlign};
  padding: ${({ padding }) => padding};
  position: sticky !important;
  /* top: ${({isDiffPage, isTopStagesOpen, isGarageStatsOpen}) => isDiffPage ? "0" : (isTopStagesOpen && isGarageStatsOpen)  ? "210px" : (isTopStagesOpen && !isGarageStatsOpen) ? "180px" : (!isTopStagesOpen && isGarageStatsOpen) ? "100px": "70px"}; */
  top: ${({ isDiffPage, isTopStagesOpen, isGarageStatsOpen }) => {
    if (isDiffPage) return "0";
    if (isTopStagesOpen && isGarageStatsOpen) return "210px";
    if (isTopStagesOpen && !isGarageStatsOpen) return "180px";
    if (!isTopStagesOpen && isGarageStatsOpen) return "100px";
    return "70px";
  }};
  border-bottom: 1px solid;
  border-color: ${({theme})=> theme.mainBorderColor};
  z-index: 6;
`
const PageTopTitle = ({title, isDiffPage=false, textAlign= "center",position="static", top, padding = "7px 30px"}) => {

  const {
    topStagesState,
    garageStatsState,
  } = useSelector((state) => state.layout);

  return (
    <Container padding={padding} isDiffPage textAlign={textAlign} position={position} top={top} isTopStagesOpen={topStagesState} isGarageStatsOpen={garageStatsState === "open"}>
        {title}
    </Container>
  )
}

export default PageTopTitle